export const SPACES = {
  l: '1.5rem',
  m: '1rem',
  s: '0.5rem'
};